import { render, staticRenderFns } from "./feeLists.vue?vue&type=template&id=3e1487a5&scoped=true&"
import script from "./feeLists.vue?vue&type=script&lang=js&"
export * from "./feeLists.vue?vue&type=script&lang=js&"
import style0 from "./feeLists.vue?vue&type=style&index=0&id=3e1487a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1487a5",
  null
  
)

export default component.exports